import './App.css';
import logo from './assets/images/cadre1/logoEcoleDavid.webp';
import davidImg from './assets/images/cadre1/David.webp';
import guitareBasse from './assets/images/cadre1/Guitare et basse.webp';
import tel from './assets/images/cadre1/phone-call.webp';
import Enveloppe from './assets/images/cadre1/email.webp';
import Lieu from './assets/images/cadre1/Lieu.webp';
import Horloge from './assets/images/cadre1/Horloge.webp';
import logoVu from './assets/images/Photo/Logo Vu.webp';
import sprintImg from './assets/images/sprint.svg';

// Photos du magasin
import photoSalle from './assets/images/Photo/Salle.webp';
import photoStudio from './assets/images/Photo/Studio.webp';
import photoAttelier from './assets/images/Photo/Attelier.webp';
import photoVitrine from './assets/images/Photo/Vitrine.webp';
import photoVitrine1 from './assets/images/Photo/Vitrine 1.webp';

// Images catégories
import imgElectrique from './assets/images/Categories/Guitare Electrique.webp';
import imgFolk from './assets/images/Categories/Guitare Folk.webp';
import imgElectroacc from './assets/images/Categories/Guitare Electroaccoustique Bis.webp';
import imgClassique from './assets/images/Categories/Guitare classic.webp';
import imgBasse from './assets/images/Categories/Basse.webp';
import imgGaucher from './assets/images/Categories/Guitare Gaucher.webp';
import imgAmpGuitare from './assets/images/Categories/Ampli Electrique.webp';
import imgAmpBasse from './assets/images/Categories/Ampli basse.webp';
import imgAmpElectroacc from './assets/images/Categories/Ampli Electroaccoustique.webp';
import imgAccessoires from './assets/images/Categories/Accesoire Pedale.webp';
// Dans App.jsx, ajoutez l'import
import { useNavigate } from 'react-router-dom';

// Dans le JSX des catégories, remplacez scrollToProduits par goToProduits :
// onClick={() => goToProduits(cat.value)}

// Pour le bouton "Voir tous les produits" du hero :
// onClick={() => navigate('/produits')}


import Annonce from './component/Annonce/Annonce';
import { useEffect, useMemo, useRef, useState } from 'react';
import { store } from './firebase.config';
import { getDocs, collection, getDoc, doc, query, orderBy, limit } from 'firebase/firestore';
import { useLocation } from 'react-router-dom';

const CATEGORIES = [
  { value: 'Electrique',     label: 'GUITARES ÉLECTRIQUES',      img: imgElectrique },
  { value: 'Folk',           label: 'GUITARES FOLK',             img: imgFolk },
  { value: 'Electroacc',     label: 'GUITARES ÉLECTROACOUSTIQUES', img: imgElectroacc },
  { value: 'Classique',      label: 'GUITARES CLASSIQUES',       img: imgClassique },
  { value: 'Basse',          label: 'BASSES',                    img: imgBasse },
  { value: 'Gaucher',        label: 'GUITARES GAUCHERS',         img: imgGaucher },
  { value: 'AmpGuitare',     label: 'AMPLIS GUITARES',           img: imgAmpGuitare },
  { value: 'AmpBasse',       label: 'AMPLIS BASSES',             img: imgAmpBasse },
  { value: 'AmpElectroacc',  label: 'AMPLIS ÉLECTROACOUSTIQUES', img: imgAmpElectroacc },
  { value: 'Accessoires',    label: 'ACCESSOIRES DIVERS',        img: imgAccessoires },
];



function App() {
  const location = useLocation();

  const [objects, setObjects]         = useState([]);
  const [categorie, setCategorie]     = useState('');
  const [prix, setPrix]               = useState('');
  const [searchTerm, setSearchTerm]   = useState('');
  const [showHoraires, setShowHoraires] = useState(false);

  const [acceuilPhrase, setAcceuilPhrase] = useState([]);
  const [sousTitre, setSousTitre]         = useState([]);
  const [titre, setTitre]                 = useState('');
  const [bannerSousTitre, setBannerSousTitre] = useState('');
  const [horaires, setHoraires]           = useState({});
  const [articles, setArticles]           = useState([]);
  const [avis, setAvis]                   = useState([]);

  const prixSelectorRef       = useRef(null);
  const categorieSelectorRef  = useRef(null);
  const produitsRef           = useRef(null);

  const clickVisite = () => window.open('https://maps.app.goo.gl/7Fu7xmWCVnfqsDpQ7', '_blank');

  // Fonction de scroll avec offset pour laisser de l'espace au header
  const scrollToSection = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      const headerHeight = 120; // Hauteur approximative du header
      const elementPosition = element.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
  };


// Dans le composant
const navigate = useNavigate();

// Navigation vers la page Produits
const goToProduits = (cat = '') => {
  const params = new URLSearchParams();
  if (cat) params.set('cat', cat);
  navigate(`/produits?${params.toString()}`);
};

// Fonction pour parser le texte avec les délimiteurs (%, <br>, etc.)
const parseText = (text) => {
  if (!text) return null;
  
  return text.split('%').filter(Boolean).map((para, i) => (
    <p key={i}>{para.trim()}</p>
  ));
};


  // ---------- INIT ----------
  useEffect(() => {
    let mounted = true;
    async function initPage() {
      const list = [];
      // Charger seulement 10 objets triés par date récente
      const q = query(collection(store, 'object'), orderBy('date', 'desc'), limit(10));
      const documents = await getDocs(q);
      documents.docs.forEach((d) => list.push({ ...d.data(), id: d.id }));

      const custom = await getDoc(doc(store, 'custom/3OLblya5h9o2STSSkXs8'));
      const ap = [(custom.data()?.article_1_Content || '')];
      const st = (custom.data()?.sousTitre || '').split('%').filter(Boolean);
      const t = custom.data()?.titre || '';
      const bst = custom.data()?.bannerSousTitre || '';

      // Récupérer les 4 articles depuis le document custom
      const articlesData = [];
      const customData = custom.data();
      for (let i = 1; i <= 4; i++) {
        const titre = customData?.[`article_${i}_Titre`] || '';
        const contenu = customData?.[`article_${i}_Content`] || '';
        
        if (titre && contenu) {
          articlesData.push({
            id: `article_${i}`,
            titre: titre,
            contenu: contenu
          });
        }
      }

      // Récupérer les 6 avis depuis la collection avis
      const avisData = [];
      const avisQuery = query(collection(store, 'avis'), orderBy('date', 'desc'), limit(6));
      const avisDocuments = await getDocs(avisQuery);
      avisDocuments.docs.forEach((d) => avisData.push({ ...d.data(), id: d.id }));

      if (!mounted) return;
      setAcceuilPhrase(ap);
      setSousTitre(st);
      setTitre(t);
      setBannerSousTitre(bst);
      setHoraires(custom.data()?.horaire || {});
      setArticles(articlesData);
      setAvis(avisData);
      setObjects(list);

      const filtres = location.state?.filtres;
      if (filtres) {
        setCategorie(filtres.cat || '');
        setPrix(filtres.prix || '');
      }
    }
    initPage();
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (categorieSelectorRef.current) categorieSelectorRef.current.value = categorie;
    if (prixSelectorRef.current)      prixSelectorRef.current.value      = prix;
    
    // Scroller vers les catégories si on revient avec une catégorie présélectionnée
    if (categorie && location.state?.filtres?.cat) {
      setTimeout(() => {
        const element = document.getElementById('apropos');
        if (element) {
          const headerHeight = 120;
          const elementPosition = element.getBoundingClientRect().top + window.scrollY - headerHeight;
          window.scrollTo({ top: elementPosition, behavior: 'smooth' });
        }
      }, 100);
    }
  }, [categorie, prix, location.state]);

  // ---------- Derived ----------
  const featured = useMemo(
    () => [...objects].sort((a, b) => (b.date || 0) - (a.date || 0)).slice(0, 4),
    [objects]
  );

  const filteredObjects = useMemo(() => {
    const base = [...objects];
    const sorted =
      prix === ''
        ? base.sort((a, b) => (b.date || 0) - (a.date || 0))
        : base.sort((a, b) =>
            parseInt(a.prixFix || a.prix || 0, 10) - parseInt(b.prixFix || b.prix || 0, 10)
          );
    return sorted
      .filter((o) => (categorie === '' ? true : o.categorie === categorie))
      .filter((o) => (prix     === '' ? true : o.prix      === prix))
      .filter((o) =>
        searchTerm === ''
          ? true
          : (o.titre || o.name || '').toLowerCase().includes(searchTerm.toLowerCase())
      );
  }, [objects, categorie, prix, searchTerm]);

  const scrollToProduits = (cat = '') => {
    setCategorie(cat);
    setPrix('');
    setSearchTerm('');
    setTimeout(() => produitsRef.current?.scrollIntoView({ behavior: 'smooth' }), 50);
  };

  return (
    <div className="AppShell">

      {/* ═══════════════════════════════════════
          TOPBAR
      ═══════════════════════════════════════ */}
      <header className="Topbar">
        <div className="Topbar__top">
          {/* Brand */}
          <div className="Topbar__brand" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img className="Topbar__logo" src={logo} alt="Logo" />
            <div className="Topbar__titles">
              <div className="Topbar__title">SHOP</div>
              <div className="Topbar__subtitle">Vente d&apos;instrument d&apos;occasion</div>
            </div>
          </div>

          {/* Adresse + mail */}
          <div className="Topbar__info">
            <span>
              <img src={Lieu} alt="" className="Topbar__infoIcon" />
              12 Rue Pasteur<br />71100 Chalon sur Saône
            </span>
            <span>
              <img src={Enveloppe} alt="" className="Topbar__infoIcon" />
              david.foucard@gmail.com
            </span>
          </div>
        </div>

        {/* Barre secondaire : horaires / recherche / appeler */}
        <div className="Topbar__bar">
          <div className="Topbar__bar-item" onClick={() => setShowHoraires(!showHoraires)}>
            <img src={Horloge} alt="" className="Topbar__barIcon" />
            <span>Horaires</span>
          </div>

          <div className="Topbar__search">
            <span className="Topbar__searchIcon"></span>
            <input
              className="Topbar__searchInput"
              placeholder="RECHERCHER"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && searchTerm.trim()) {
                  navigate(`/produits?q=${encodeURIComponent(searchTerm)}`);
                }
              }}
              onFocus={() => navigate('/produits')}
            />
          </div>

          <a className="Topbar__bar-item" href="tel:0663460105">
            <img src={tel} alt="" className="Topbar__barIcon" />
            <span>Appeler</span>
          </a>
        </div>

        {/* Dropdown horaires */}
        {showHoraires && (
          <div className="HorairesDrop">
            <table>
              <tbody>
                <tr><td>Mardi</td><td>{horaires['mardi']}</td></tr>
                <tr><td>Mercredi</td><td>{horaires['mercredi']}</td></tr>
                <tr><td>Vendredi</td><td>{horaires['vendredi']}</td></tr>
                <tr><td>Samedi</td><td>{horaires['samedi']}</td></tr>
              </tbody>
            </table>
          </div>
        )}
      </header>

      <main className="Main">

        {/* ═══════════════════════════════════════
            HERO BANNER
        ═══════════════════════════════════════ */}
        <section className="Hero" onClick={clickVisite}>
          <img className="Hero__bg" src={photoVitrine} alt="Vitrine guitares" />
          <div className="Hero__overlay">
            <div className="Hero__left">
              <img className="Hero__logo" src={logo} alt="Logo École David" />
            </div>
            <div className="Hero__right">
              <div className="Hero__shopWord">SHOP</div>
            </div>
          </div>
          <div className="Hero__banner">
            <button className="Hero__visitBtn" onClick={(e) => {e.stopPropagation(); clickVisite();}}>
              Cliquer pour visiter
            </button>
          </div>
        </section>

        {/* ═══════════════════════════════════════
            SOUS-TITRE HERO
        ═══════════════════════════════════════ */}
        <section className="HeroBanner">
          <div className="HeroBanner__text">
            {titre}
          </div>
          {bannerSousTitre && (
            <div className="HeroBanner__subtitle">
              {bannerSousTitre}
            </div>
          )}
        </section>

        {/* ═══════════════════════════════════════
            NOS CATÉGORIES
        ═══════════════════════════════════════ */}
        <section className="CatSection" id="apropos">
          <h2 className="SectionTitle">NOS CATÉGORIES</h2>
          <div className="CatGrid">
            {CATEGORIES.map((cat) => (
              <button
                key={cat.value}
                className="CatCard"
                onClick={() => goToProduits(cat.value)}
              >
                <img src={cat.img} alt={cat.label} className="CatCard__img" />
                <div className="CatCard__label">{cat.label}</div>
              </button>
            ))}
          </div>
        </section>

        {/* ═══════════════════════════════════════
            BLOC ORANGE : services
        ═══════════════════════════════════════ */}
        <section className="Services">
          <div className="Services__orange">
            <img src={logoVu} alt="Logo Vu" className="Services__orangeLogo" />
            <p onClick={() => scrollToSection('section-reprise')} style={{cursor: 'pointer'}}><strong>{articles[0]?.titre || 'RACHAT D\'INSTRUMENTS'}</strong></p>
              <p onClick={() => scrollToSection('section-cours')} style={{cursor: 'pointer'}}><strong>{articles[1]?.titre || 'COURS DE GUITARE ET BASSE'}</strong></p>
              <p onClick={() => scrollToSection('section-atelier')} style={{cursor: 'pointer'}}><strong>{articles[2]?.titre || 'ATELIER DE MAINTENANCE & RÉPARATION'}</strong></p>
            
          
            <p onClick={() => scrollToSection('section-fondateur')} style={{cursor: 'pointer'}}><strong>{articles[3]?.titre || 'DAVID FOUCARD'}</strong></p>
          </div>
          <div className="Services__photo">
            <img src={photoSalle} alt="Salle" />
          </div>
        </section>

        {/* ═══════════════════════════════════════
            NOUVEAUTÉS
        ═══════════════════════════════════════ */}
        <section className="Featured" id="produits">
          <h2 className="SectionTitle">NOUVEAUTÉS</h2>
          <div className="Featured__row">
            {featured.map((object) => (
              <div key={object.id} className="CardWrap">
                <Annonce prix={prix} cat={categorie} data={object} horaires={horaires} />
              </div>
            ))}
          </div>
        </section>

        {/* ═══════════════════════════════════════
            VOUS SOUHAITEZ VENDRE / COURS / ATELIER
        ═══════════════════════════════════════ */}
        <section className="InfoBlocks">

          {/* Vendre */}
          <div className="InfoBlock InfoBlock--full" id="section-reprise">
            <div className="InfoBlock__text">
              <h3 className="InfoBlock__title">{articles[0]?.titre || 'RACHAT D\'INSTRUMENTS'}</h3>
              <div className="Paragraph">
                {articles[0]?.contenu && parseText(articles[0].contenu)}
              </div>
            </div>
            <div className="InfoBlock__photo">
              <img src={photoStudio} alt="Studio" />
            </div>
          </div>

          {/* Cours */}
          <div className="InfoBlock InfoBlock--cours" id="section-cours">
            <div className="InfoBlock__text">
              <h3 className="InfoBlock__title">{articles[1]?.titre || 'COURS DE GUITARE ET DE BASSE'}</h3>
              <div className="Paragraph">
                {articles[1]?.contenu && parseText(articles[1].contenu)}
              </div>
              <a
                className="SchoolLink"
                href="http://ecole-guitare-basse.fr/"
                target="_blank"
                rel="noreferrer"
              >
                École Guitare et Basse →
              </a>
            </div>
            <div className="InfoBlock__photo">
              <img src={guitareBasse} alt="Cours de guitare et basse" />
            </div>
          </div>

          {/* Atelier */}
          <div className="InfoBlock InfoBlock--atelier" id="section-atelier">
            <div className="InfoBlock__text">
              <h3 className="InfoBlock__title">{articles[2]?.titre || 'ATELIER DE MAINTENANCE & RÉPARATION'}</h3>
              <div className="Paragraph">
                {articles[2]?.contenu && parseText(articles[2].contenu)}
              </div>
            </div>
            <div className="InfoBlock__photo">
              <img src={photoAttelier} alt="Atelier" />
            </div>
          </div>

          {/* Le fondateur */}
          <div className="InfoBlock InfoBlock--fondateur" id="section-fondateur">
            <div className="InfoBlock__content">
              <div className="InfoBlock__text">
                <h3 className="InfoBlock__title">{articles[3]?.titre || 'DAVID FOUCARD'}</h3>
                <div className="Paragraph">
                  {articles[3]?.contenu && parseText(articles[3].contenu)}
                </div>
              </div>
              <img src={davidImg} alt="David Foucard" className="InfoBlock__image" />
            </div>
          </div>

        </section>

        {/* ═══════════════════════════════════════
            FILTRES + GRILLE PRODUITS
        ═══════════════════════════════════════ */}
        {/* <section className="Filters" ref={produitsRef} id="produits-liste">
          <select
            ref={categorieSelectorRef}
            className="Select"
            onChange={(e) => setCategorie(e.target.value)}
            defaultValue=""
          >
            <option value="">Toutes catégories</option>
            <option value="Electrique">Électrique</option>
            <option value="Folk">Folk</option>
            <option value="Classique">Classique</option>
            <option value="Electroacc">Électroacoustique</option>
            <option value="Gaucher">Gaucher</option>
            <option value="Basse">Basse</option>
            <option value="Accessoires">Accessoires</option>
            <option value="AmpBasse">Ampli basse</option>
            <option value="AmpGuitare">Ampli guitare</option>
            <option value="AmpElectroacc">Ampli électroacoustique</option>
          </select>

          <select
            ref={prixSelectorRef}
            className="Select"
            onChange={(e) => setPrix(e.target.value)}
            defaultValue=""
          >
            <option value="">Tous les prix</option>
            <option value="0-100">Accessoires (0–100 €)</option>
            <option value="100-300">Entrée de gamme (100–300 €)</option>
            <option value="+300">Moyenne gamme (+300 €)</option>
            <option value="+700">Haute gamme (+700 €)</option>
            <option value="+2000">Très haute gamme (+2000 €)</option>
          </select>

          {(categorie || prix || searchTerm) && (
            <button
              className="Btn Btn--ghost Btn--small"
              onClick={() => { setCategorie(''); setPrix(''); setSearchTerm(''); }}
            >
              ✕ Effacer les filtres
            </button>
          )}
        </section>

        <section className="Grid">
          {filteredObjects.length === 0 && (
            <p className="Grid__empty">Aucun produit ne correspond à votre recherche.</p>
          )}
          {filteredObjects.map((object) => (
            <div key={object.id} className="CardWrap">
              <Annonce prix={prix} cat={categorie} data={object} horaires={horaires} />
            </div>
          ))}
        </section> */}

        {/* ═══════════════════════════════════════
            AVIS CLIENTS
        ═══════════════════════════════════════ */}
        <section className="Reviews">
          <div className="Reviews__header">
       
            <p className="Reviews__subtitle">Avis clients</p>
          </div>
          <div className="Reviews__grid">
            {avis.length > 0 ? (
              avis.map((review) => (
                <div key={review.id} className="ReviewCard">
                  <div className="ReviewCard__stars">
                    {Array.from({ length: review.stars || 5 }).map((_, i) => (
                      <span key={i}>★</span>
                    ))}
                  </div>
                  <p><strong>« {review.titre} »</strong></p>
                  {review.contenu && (
                    parseText(review.contenu)
                  )}
                </div>
              ))
            ) : (
              <>
                <div className="ReviewCard">
                  <div className="ReviewCard__stars">★★★★★</div>
                  <p><strong>« David l'avis d'un pro »</strong></p>
                  <p>
                    Je suis venu chez Guitare &amp; Basse Shop pour chercher une guitare d'occasion et j'ai été très bien conseillé. David prend vraiment le temps d'écouter, de faire essayer plusieurs instruments et d'expliquer les différences.
                  </p>
                  <p>
                    On sent immédiatement qu'il est passionné et très compétent. Les guitares sont très bien réglées et prêtes à jouer, ce qui fait une vraie différence.
                  </p>
                  <p>
                    Je suis reparti avec une guitare qui me correspond parfaitement. Un vrai magasin de passionné comme on en trouve de moins en moins. Je recommande vivement.
                  </p>
                </div>

                <div className="ReviewCard">
                  <div className="ReviewCard__stars">★★★★★</div>
                  <p><strong>« Super magasin de guitare. »</strong></p>
                  <p>
                    David est passionné, prend le temps de conseiller et ne pousse pas à l'achat. On sent quelqu'un qui aime vraiment les instruments et la musique.
                  </p>
                </div>

                <div className="ReviewCard">
                  <div className="ReviewCard__stars">★★★★★</div>
                  <p><strong>« Un vrai spécialiste de la guitare. »</strong></p>
                  <p>
                    Large choix de guitares d'occasion très bien réglées. Les instruments sont préparés avec soin et prêts à jouer.
                  </p>
                </div>

                <div className="ReviewCard">
                  <div className="ReviewCard__stars">★★★★★</div>
                  <p><strong>« Excellent accueil et très bons conseils. »</strong></p>
                  <p>
                    On peut essayer tranquillement les instruments et discuter musique. Rare aujourd'hui de trouver un magasin aussi humain.
                  </p>
                </div>

                <div className="ReviewCard">
                  <div className="ReviewCard__stars">★★★★★</div>
                  <p><strong>« Un lieu incontournable pour les guitaristes. »</strong></p>
                  <p>
                    David connaît parfaitement ses instruments et aide vraiment à trouver la guitare qui correspond au musicien.
                  </p>
                </div>

                <div className="ReviewCard">
                  <div className="ReviewCard__stars">★★★★★</div>
                  <p><strong>« Magasin sérieux et passionné. »</strong></p>
                  <p>
                    Beaucoup de choix, des prix honnêtes et surtout un vrai service derrière les instruments.
                  </p>
                </div>
              </>
            )}
          </div>
        </section>

        {/* ═══════════════════════════════════════
            FOOTER
        ═══════════════════════════════════════ */}
        <footer className="Footer" id="contact">
          <div className="Footer__inner">
            <div className="Footer__col">
              <strong>Contact</strong>
              <div><img src={tel} alt="" className="Footer__icon" /><a href="tel:0663460105">06 63 46 01 05</a></div>
              <div><img src={Enveloppe} alt="" className="Footer__icon" /><a href="mailto:david.foucard@gmail.com">david.foucard@gmail.com</a></div>
            </div>

            <div className="Footer__col">
              <strong>Adresse</strong>
              <div><img src={Lieu} alt="" className="Footer__icon" />12 Rue Pasteur, 71100 Chalon-sur-Saône</div>
              <button className="Btn Btn--ghost Btn--small" onClick={clickVisite}>📍 Itinéraire</button>
            </div>

            <div className="Footer__col">
              <strong>Horaires</strong>
              <div><img src={Horloge} alt="" className="Footer__icon" /></div>
              <table className="Footer__hours">
                <tbody>
                  <tr><td>Mardi</td><td>{horaires['mardi']}</td></tr>
                  <tr><td>Mercredi</td><td>{horaires['mercredi']}</td></tr>
                  <tr><td>Vendredi</td><td>{horaires['vendredi']}</td></tr>
                  <tr><td>Samedi</td><td>{horaires['samedi']}</td></tr>
                </tbody>
              </table>
            </div>

            <div className="Footer__col">
              <strong>Liens</strong>
              <div><a href="http://ecole-guitare-basse.fr/" target="_blank" rel="noreferrer">École Guitare et Basse</a></div>
              <div><a href="#apropos">À propos</a></div>
              <div><a href="#produits">Produits</a></div>
            </div>
          </div>

          <div className="Footer__bottom">
            © {new Date().getFullYear()} — Guitare &amp; Basse Shop Chalon - version 2.0
          </div>
        </footer>

      </main>
    </div>
  );
}

export default App;
